import {Component, EventEmitter, Input, Output} from '@angular/core';
import {File} from '../../../models';
import {MatTableDataSource} from "@angular/material/table";
import {v4 as uuid} from 'uuid';
import {MatDialog} from "@angular/material/dialog";
import {
  FileManagerDialogControllerComponent
} from "../file-manager-dialog/file-manager-dialog-controller/file-manager-dialog-controller.component";

@Component({
  selector: 'app-file-manager-controller',
  templateUrl: './file-manager-controller.component.html',
  styleUrls: ['./file-manager-controller.component.scss']
})
export class FileManagerControllerComponent {

  @Output() files: EventEmitter<File[]> = new EventEmitter();
  @Input() existingDocuments: any[] = [];

  constructor(private dialog: MatDialog) {}

  fileList: File[] = [];
  displayedColumns: string[] = ['fileName', 'fileDescription', 'actions'];
  dataSource = new MatTableDataSource<File>();

  removeFile(fileId: string): void {
    this.fileList = this.fileList.filter((file, i) => file.documentId !== fileId);
    this.files.emit(this.fileList);
    this.dataSource.data = this.fileList;
  }

  getCurrentTotalSize(): number {
    return (this.fileList || []).reduce((acc, f) => {
      const size = f.content ? Math.round((f.content.length * 3) / 4) : 0;
      return acc + size;
    }, 0);
  }

  openDialog(): void {
    const existingFileNames = [
      ...this.fileList.map(f => f.fileName),
      ...(this.existingDocuments || []).map(d => d.fileName)
    ].filter(Boolean);

    const dialogRef = this.dialog.open(FileManagerDialogControllerComponent, {
      height: '480px',
      width: '600px',
      data: {
        existingFileNames,
        currentTotalSize: this.getCurrentTotalSize()
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.fileName) return;

      const action = result.documentAction;
      const matchingIndex = this.fileList.findIndex(
        f => f.fileName?.toLowerCase().trim() === result.fileName?.toLowerCase().trim()
      );

      if (action === 'replace' && matchingIndex !== -1) {
        // Replace existing document
        this.fileList[matchingIndex] = {
          ...this.fileList[matchingIndex],
          description: result.fileDescription,
          content: result.fileContent
        };
      } else if (action === 'append' && matchingIndex !== -1) {
        // Append to existing document
        const existing = this.fileList[matchingIndex];
        this.fileList[matchingIndex] = {
          ...existing,
          description: `${existing.description} | ${result.fileDescription}`,
          content: `${existing.content}\n${result.fileContent}`
        };
      } else {
        // Add as new document
        this.fileList.push({
          documentId: uuid(),
          description: result.fileDescription,
          fileName: result.fileName,
          content: result.fileContent,
        });
      }
      
      this.files.emit(this.fileList);
      this.dataSource.data = this.fileList;
    });
  }
}
